<template>
  <OutgoingReturnForm
    formTitle="Buat Retur Kelebihan"
    defaultDescription="Kelebihan"
  />
</template>

<script>
import OutgoingReturnForm from './OutgoingReturnForm.vue'
export default {
  components: { OutgoingReturnForm }
}
</script>
